export default __webpack_public_path__ + "static/Крысиные бега_22-70219f2669376b5e97141c330b89c5a1.jpg";